import { DialogChat } from "../../types/DialogChat";

export type GlobalChatIntent =
  | {
      type: "none";
    }
  | {
      type: "open-chat";
      chatId: string;
    }
  | {
      type: "open-or-create-direct-chat";
      targetUserId: string;
    };

export type GlobalChatRouteState = {
  chatId?: unknown;
  userId?: unknown;
  targetUserId?: unknown;
  userIdForCreate?: unknown;
  adimId?: unknown;
  adminId?: unknown;
};

export type ResolveGlobalChatIntentInput = {
  searchParams: URLSearchParams;
  routeState?: GlobalChatRouteState | null;
  directUserId?: string | null;
  currentUserId?: string;
};

const getStringValue = (value: unknown) =>
  typeof value === "string" && value.trim() ? value.trim() : undefined;

export const resolveGlobalChatIntent = ({
  searchParams,
  routeState,
  directUserId,
  currentUserId,
}: ResolveGlobalChatIntentInput): GlobalChatIntent => {
  const chatId =
    getStringValue(searchParams.get("chatId")) ??
    getStringValue(routeState?.chatId);

  if (chatId) {
    return {
      type: "open-chat",
      chatId,
    };
  }

  const targetUserId =
    getStringValue(searchParams.get("userId")) ??
    getStringValue(searchParams.get("targetUserId")) ??
    getStringValue(searchParams.get("userIdForCreate")) ??
    getStringValue(routeState?.userId) ??
    getStringValue(routeState?.targetUserId) ??
    getStringValue(routeState?.userIdForCreate) ??
    getStringValue(directUserId) ??
    getStringValue(routeState?.adimId) ??
    getStringValue(routeState?.adminId);

  if (targetUserId && targetUserId !== currentUserId) {
    return {
      type: "open-or-create-direct-chat",
      targetUserId,
    };
  }

  return {
    type: "none",
  };
};

export const getGlobalChatIntentKey = (intent: GlobalChatIntent) => {
  if (intent.type === "open-chat") {
    return `${intent.type}:${intent.chatId}`;
  }

  if (intent.type === "open-or-create-direct-chat") {
    return `${intent.type}:${intent.targetUserId}`;
  }

  return intent.type;
};

export const findDialogChatForIntent = (
  chats: DialogChat[],
  intent: GlobalChatIntent,
) => {
  if (intent.type === "open-chat") {
    return chats.find((chat) => chat._id === intent.chatId);
  }

  if (intent.type === "open-or-create-direct-chat") {
    return chats.find((chat) =>
      chat.members.some((member) => member._id === intent.targetUserId),
    );
  }

  return undefined;
};
